import { useParams, Navigate } from "react-router-dom";
import SubcategoryPageLayout from "@/components/SubcategoryPageLayout";
import outdoorSubs from "@/data/outdoorSubcategories";

const OutdoorSubcategoryPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const sub = slug ? outdoorSubs[slug] : null;

  if (!sub) return <Navigate to="/outdoor" replace />;

  return (
    <SubcategoryPageLayout
      heading={sub.heading}
      subtitle={sub.subtitle}
      categoryKey={sub.categoryKey}
      backTo="/outdoor"
      backLabel="Outdoor & Soluzioni Ombra"
    />
  );
};

export default OutdoorSubcategoryPage;
